import { render, staticRenderFns } from "./TransferReceiptVoucherCreateView.vue?vue&type=template&id=785771a2"
import script from "./TransferReceiptVoucherCreateView.vue?vue&type=script&lang=js"
export * from "./TransferReceiptVoucherCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports